var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('PageHeader',{attrs:{"title":"Atsisakytos finansavimo užklausos","subtitle":"Čia galite peržiūrėti, atsisakytas finansavimo užklausas"}}),_c('DataTable',{ref:"declinedFundingRequestsTable",attrs:{"table":_vm.table}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }